import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function StudentList(): React.ReactElement {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#student_list)">
        <path d="M11.9964 11.9577C14.0099 11.9577 15.6422 10.3254 15.6422 8.31184C15.6422 6.29831 14.0099 4.66602 11.9964 4.66602C9.98288 4.66602 8.35059 6.29831 8.35059 8.31184C8.35059 10.3254 9.98288 11.9577 11.9964 11.9577Z" />
        <path d="M19.2907 14.042C20.7289 14.042 21.8948 12.8761 21.8948 11.4379C21.8948 9.99965 20.7289 8.83374 19.2907 8.83374C17.8524 8.83374 16.6865 9.99965 16.6865 11.4379C16.6865 12.8761 17.8524 14.042 19.2907 14.042Z" />
        <path d="M4.77894 14.042C6.21716 14.042 7.38307 12.8761 7.38307 11.4379C7.38307 9.99965 6.21716 8.83374 4.77894 8.83374C3.34071 8.83374 2.1748 9.99965 2.1748 11.4379C2.1748 12.8761 3.34071 14.042 4.77894 14.042Z" />
        <path d="M11.9974 12.9988C8.26404 12.9988 5.22656 16.0363 5.22656 19.7696C5.22656 20.0571 5.45991 20.2904 5.74741 20.2904H18.2473C18.5348 20.2904 18.7682 20.0571 18.7682 19.7696C18.7682 16.0363 15.7307 12.9988 11.9974 12.9988Z" />
        <path d="M5.67789 15.196C5.35914 15.1283 5.03517 15.0835 4.70602 15.0835C2.12166 15.0835 0.0185547 17.1866 0.0185547 19.771C0.0185547 20.0585 0.251903 20.2918 0.539401 20.2918H4.28102C4.22268 20.1283 4.18518 19.9543 4.18518 19.771C4.18518 18.0616 4.74352 16.4835 5.67789 15.196Z" />
        <path d="M19.2893 15.0835C18.9601 15.0835 18.6361 15.1283 18.3174 15.196C19.2518 16.4835 19.8101 18.0616 19.8101 19.771C19.8101 19.9543 19.7726 20.1282 19.7142 20.2918H23.4559C23.7434 20.2918 23.9767 20.0585 23.9767 19.771C23.9767 17.1866 21.8736 15.0835 19.2893 15.0835Z" />
      </g>
      <defs>
        <clipPath id="student_list">
          <rect width="23.9582" height="23.9582" transform="translate(0.0185547 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
